export const LOSS_EXPORT_ID = "Reporte - Merma";
export const LOSS_TITLE = "Reporte - Merma";

export const LOSS_PROPERTIES = {
  subRoute: "Ruta",
  trip: "Viaje",
  username: "Usuario",
  invoice: "No. Entrega",
  serial: "No. Documento",
  createDateTimeDate: "Fecha de Creación",
  createDateTimeHour: "Hora de Creación",
  updateAuditAtDate: "Fecha de Modificación",
  updateAuditAtHour: "Hora de Modificación",
  soldToName: "Solicitante",
  materialCode: "Material",
  materialName: "Denominación",
  deliveredUMBUnit: "UMB Entrega",
  deliveredUMB: "Cantidad Entrega UMB",
  deliveredUMPUnit: "UMP Entrega",
  deliveredUMP: "Cantidad Entrega UMP",
  qtyMermaUMBUnit: "UMB Merma",
  qtyMermaUMB: "Cantidad Merma UMB",
  qtyMermaUMPUnit: "UMP Merma",
  qtyMermaUMP: "Cantidad Merma UMP",
  percentageMerma: "% Merma",
  netPrice: "Precio Neto",
  netValue: "Valor Neto",
  comment: "Comentario",
  reasonRejections: "Razones de rechazo",
};

export const CURRENCYFIELDS = ["unitPrice", "total"];

export const FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("es-HN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  //   second: '2-digit',
  //   hour12: false // Formato 24 horas
});
